import StepBadge from '@/components/ui/StepBadge.tsx';
import { ChangePackageStep } from '@/features/dashboard/bookingChanges/routes/changePackageSearch.ts';
import {
  CHANGE_PACKAGE_STEP_COUNT,
  changePackageStepNumber,
} from './changePackageSteps.ts';

interface ChangePackageStepBadgeProps
  extends React.HTMLAttributes<HTMLDivElement> {
  step: ChangePackageStep;
  /** Dopisek obok odznaki: „Paczka #13 · szkic”, „Paczka #13 · dopłata 240,00 zł”. */
  context: string;
}

/**
 * Odznaka kroku wprowadzania paczki. Numer kroku wynika z enuma trasy, więc
 * przelicza go moduł, a wygląd niesie wspólny `StepBadge`.
 */
const ChangePackageStepBadge = ({
  step,
  ...props
}: ChangePackageStepBadgeProps) => (
  <StepBadge
    current={changePackageStepNumber(step)}
    total={CHANGE_PACKAGE_STEP_COUNT}
    {...props}
  />
);

export default ChangePackageStepBadge;
